import { getSportPositions } from '../models/concerns/position'

export function sortPlayers(a, b, context, sport) {
  const order = getSportPositions(sport)
  var ret = (a.position ? order.indexOf(a.position) : Infinity) -
    (b.position ? order.indexOf(b.position) : Infinity)
  if(ret) return ret
  if(context === 'prices') {
    ret = a.formalName.localeCompare(b.formalName)
    if(ret) return ret
    ret = (a.shirt || Infinity) - (b.shirt || Infinity)
    return ret
  } else {
    ret = (a.shirt || Infinity) - (b.shirt || Infinity)
    if(ret) return ret
    ret = a.formalName.localeCompare(b.formalName)
    return ret
  }
}

export function used(players) {
  const order = getSportPositions()
  var ret = {}
  players.forEach(p => {
    if(p.position) ret[p.position] = true
  })
  return Object.keys(ret).sort((a, b) => {
    return order.indexOf(a) - order.indexOf(b)
  })
}

// Default export for backward compatibility
export default getSportPositions()
